import hexToRgba from 'hex-to-rgba';

import { colors } from './colors';

export const shadow = {
  main: [0, 4, 7, hexToRgba(colors.black, 0.03)],
  navigationSidebar: [3, 0, 7, hexToRgba(colors.black, 0.03)],
  selectWrapper: [0, 4, 5, hexToRgba(colors.black, 0.07)],
};
